import { IArtifactComponentProps } from "types/services";
import { IBasic, IPropertyId } from "types/artifacts/common";
import { IPropertyDetailsArtifact } from "types/artifacts/property-details";
import { PhotosSliderWithImagePreview } from "components/PhotosSliderWithImagePreview";
import { BasicPropertyDeatilsCard } from "components/BasicPropertyDeatilsCard";
import { Highlights } from "components/Highlights";
import { findArtifactByHarid } from "utils/helpers";
import { isProduction } from "scripts/application/setting";

export type IPropertyDetailsOutputProps = IArtifactComponentProps<
  IPropertyId,
  IPropertyDetailsArtifact
>;

PropertyDetailsOutput.artifactKey = "property_detail";

export function PropertyDetailsOutput(
  props: IPropertyDetailsOutputProps
): JSX.Element {
  const { harid, artifacts } = props;

  // if there is no valid artifacts return from the backend
  if (!Array.isArray(artifacts)) return <></>;

  if (!harid) {
    console.error("No harid provided for 'PropertyDetailsOutput'.");
    return <></>;
  }

  const artifact = findArtifactByHarid(artifacts, harid);

  if (!artifact) {
    console.error(
      "No artifact found for 'PropertyDetailsOutput' with the given harid:",
      harid
    );
    return <></>;
  }

  const highlights = artifact?.response?.highlights ?? [];
  const photos = artifact?.response?.photos?.items ?? [];
  const basic = (artifact?.response?.basic || {}) as IBasic;

  return (
    <div>
      <div className="mb-3">
        <PhotosSliderWithImagePreview harid={harid} photos={photos} />
      </div>
      <div className="mb-3">
        <BasicPropertyDeatilsCard listing={basic} />
      </div>
      <div className="mb-2">
        <Highlights highlights={highlights} />
      </div>
      <p className="font_size--medium mb-2">
        {basic?.description || "No description available."}
      </p>
      <p className="font_size--medium mb-3">You can view more details at <a href={basic?.share_url} target="_blank" rel="noopener noreferrer">{basic?.street_address}</a></p>
    </div>
  );
}

PropertyDetailsOutput.asText = function (props: IPropertyDetailsOutputProps): string {
  // console.log("PropertyDetailsOutput.asText", props);
  return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.artifact_text || "" : isProduction ? "" : "PropertyDetailsOutput asText Not Implemented!";
}